module.exports = __webpack_public_path__ + "./assets/a313b060a65f2e34efd0c6b657284a8d.woff";